import { useEffect, useMemo, useState } from 'react'

import { Flex } from 'core-components/library/flex'

import { getPartnersCoverageMarkets } from '../../lib'
import { usePartnersCoverage } from '../../model'

import { CoverageReportHeader } from './components/coverageReportHeader/CoverageReportHeader'
import { CoverageReportTables } from './components/coverageReportTables/CoverageReportTables'

import styles from './CoverageReport.module.scss'

interface ICoverageReportProps {
  fYear?: number
}

export const CoverageReport = ({ fYear }: ICoverageReportProps) => {
  const { data, isLoading } = usePartnersCoverage(fYear)
  const [selectedMarketIndex, setSelectedMarketIndex] = useState(0)

  const markets = useMemo(() => getPartnersCoverageMarkets(data), [data])

  useEffect(() => {
    setSelectedMarketIndex(0)
  }, [markets])

  const selectedMarket = markets[selectedMarketIndex] ?? null

  return (
    <Flex className={styles.root} flexDirection="column" gap="xs">
      <CoverageReportHeader
        fYear={fYear}
        markets={markets}
        selectedMarketIndex={selectedMarketIndex}
        setSelectedMarketIndex={setSelectedMarketIndex}
        isLoading={isLoading}
      />

      <CoverageReportTables group={selectedMarket} isLoading={isLoading} />
    </Flex>
  )
}
